/** saves the Portfolio (List of products subscribed by the client) in our store
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_termsportfolio
*/
export const SAVE_PORTFOLIO = (state, payload) => {
    state.portfolioList = payload
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
    state.portfolioList = []
}
